
import { useParams } from 'react-router-dom';
import { AdminLayout } from '@/admin/components/AdminLayout';
import PnolDispatchDetail from '@/admin/components/pnol-dispatches/PnolDispatchDetail';

export default function PnolDispatchDetallePage() {
  const { id } = useParams<{ id: string }>();

  return (
    <AdminLayout
      title="Detalle de lote PNOL"
      subtitle="Adelantos incluidos en el archivo BCI y registro de envío"
    >
      <div className="max-w-5xl">
        {id ? (
          <PnolDispatchDetail dispatchId={id} />
        ) : (
          <div className="rounded-xl border bg-card p-6 text-sm text-muted-foreground">ID de lote no especificado.</div>
        )}
      </div>
    </AdminLayout>
  );
}
